import  _ from 'lodash'
import {
  getInspectionReport,
  getStandard,
  getStandardRecommends,
} from '@api'
import Wholesale2Store from './Wholesale2.store-module'

// namespaced
const namespaced = true

// state
const state = {
  activeList: [],
  list: {},
  cars: {},
  recommends: {},
  detail:null,
  mileage:null,

  order_number:null,
  registration_date:null,
  title:null,
  src:null,
  MileageCars: {},

  // reportEquipment
  // - 2022.08.02 车辆配置检查单
  reportEquipment: {},
}

// getters
const getters = {
  // carByCarId
  // 车辆原始数据
  carByCarId: state => id => {
    return state.cars[`raw-${id}`]
      ? state.cars[`raw-${id}`]
      : null
  },

  // titleByCarId
  // 车辆标题
  titleByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)


    if (!car)  {
      return null
    }

    return car.title
  },

  // type
  // 车辆类型
  typeByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    switch (car.car.type) {
      case '被秒': {
        return 'early-access-sold'
      }
      case '抢先报': {
        return 'early-access'
      }
      // 2021.07.27 追加
      // trello: https://trello.com/c/2byAC0ea
      case '被截胡': {
        return 'cut-off'
      }
      case '已预定': {
        return 'ordered'
      }
      case '在售': {
        return 'existed'
      }
      case '已售': {
        return 'sold'
      }
      case '下架': {
        return 'off-shelf'
      }
      default: {
        return 'existed'
      }
    }
  },

  // video
  // 车辆视频
  videoByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.video && car.car.video.length > 0
      ? car.car.video
      : null
  },

  // panorama
  // 车辆全景图
  panoramaByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.panorama
  },

  // status
  // 车辆状态
  statusByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.type
  },

  // release type
  releaseTypeByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.release_status
  },

  // tags 标签
  tagsByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const tags = _.map(car.car.tags, 'name')

    if (car.car.new_energy) {
      tags.push('新能源')
    }

    // if (
    //   car.car.original_plant_warranty === '是'
    // || car.car.original_plant_warranty === '有'
    // ) {
    //   tags.push('原厂质保')
    // }
    // else {
    //   tags.push('1年全国联保')
    // }

    if (car.original_plant_warranty){
      tags.push(car.original_plant_warranty)
    }

    if (car.car.top_version) {
      tags.push('顶配车型')
    }

    return tags
  },

  // priceByCarId 价格
  priceByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const priceRaw = car.car.price

    // price
    const price = {
      // current
      // - 挂牌价
      // - string
      current: priceRaw.current,
      // original
      // -  原价
      // - number
      original:  priceRaw.original
        ? priceRaw.original.toFixed(1)
        : null,
      // maintenanceCosts
      // - 售前修整费
      // - string
      maintenanceCosts: priceRaw.maintenance_costs,
      // finance
      // - 金融特惠价
      // -  string
      finance:  priceRaw.finance,
      // reduce
      // - 节省，比睡前指导价节省的
      // - number
      reduce: priceRaw.reduce
        ? priceRaw.reduce.toFixed(1)
        : null,
      // real
      // - 真实价格
      // - number
      real:  priceRaw.real
        ? priceRaw.real
        : null,
    }

    return price
  },

  // metasByCarId meta 信息
  metasByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const metas = car.car.meta

    if (car.car.road_engineer && car.car.road_engineer.length > 0) {
      metas.road_engineer = {
        desc: '路试工程师',
        value: car.car.road_engineer,
      }
    }

    return metas
  },

  // serviceProviderByCarId 售前检查整备实施
  serviceProviderByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.service_provider && car.car.service_provider.length > 0
      ? car.car.service_provider
      : null
  },

  // consultantByCarId 专属销售
  consultantByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.consult
  },

  // wholesaleByCarId 批发区、低价区
  wholesaleByCarId: (state, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.is_wholesale
  },

  // warrantyByCarId 质保信息
  warrantyByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.warranty_contract
  },

  // notesByCarId 车况描述
  notesByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.notes
  },

  // mileageReportByCarId 历程曲线
  mileageReportByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.mileage_report
  },

  //mileage_report_status
  mileageReportStatusByCarId: (_, {carByCarId}) => id => {

    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.mileage_report_status
  },

  // maintenanceRecordsByCarId 维保记录
  maintenanceRecordsByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.maintenance_records
  },

  // configurationChecksByCarId 功能配置单
  configurationChecksByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.configuration_checks
  },

  // suppliesStatusByCarId 耗材清单
  suppliesStatusByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.supplies_status
  },

  // outRepairListByCarId 修整清单（外部），对应有内部附件清单
  outRepairListByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.out_repair_list
  },

  // flawByCarId 瑕疵报告
  flawByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.images.flaw
  },

  // chassisByCarId 底盘照片
  chassisByCarId: (context, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    // const chassis = car.car.chassis.filter(item => item.content.length)
    const hasChassis = _.some(car.car.chassis, item => {
      return item.content.length
    })

    if (hasChassis) {
      return car.car.chassis
    }


    return hasChassis
  },

  // chassis2ByCarId 2022.06.02
  chassis2ByCarId: (context, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const hasChassis2 = car.car.chassis_important_screw

    return hasChassis2
  },

  // picSumnaryByCarId 车源图片
  picSumnaryByCarId: (store, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    // 外观
    const appearancePics = car.images && car.images.facade
      ? _.chain(car.images.facade).take(3).map('img').value()
      : []

    // 中控
    const controlPics = car.images && car.images.interior_decoration
      ? _.chain(car.images.interior_decoration).take(3).map('img').value()
      : []

    // const temp = car.images.seats
    const compartmentPics = car.images.seats
      ? _.chain(car.images.seats).takeRight(3).map('img').value()
      : []


    return [
      ...appearancePics,
      ...controlPics,
      ...compartmentPics,
    ]
  },

  // loanOfficerByCarId 金融官员
  loanOfficerByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.loan_officer
  },

  // comments 路试笔记
  commentsByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.images.note_with_images
  },

  // majorDispositionsByCarId 主要配置（低价区）
  majorDispositionsByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.car.major_dispositions
  },

  // coverByCarId
  // 车辆封面
  coverByCarId: (store, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const cover = _.chain(car.images)
      .get('cover')
      .head()
      .get('img')
      .value()

    return cover
  },

  // imagesGroupedByCategoryByCarId 图片详情对应的图片分类
  // 对应 ibs 车辆定妆照
  // - facade 外观
  // - interior_decoration 中控方向盘
  // - seats 车厢座椅
  // - attachment 后备箱及附件
  // - engine_room 机舱
  // - other 轮上及其他
  imagesGroupedByCategoryByCarId: (store, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    const desired = {
      facade: {
        name: '外观',
        value: null,
      },

      interior_decoration: {
        name: '中控方向盘',
        value: null,
      },

      seats: {
        name: '车厢座椅',
        value: null,
      },

      attachment: {
        name: '后备箱及附件',
        value: null,
      },

      engine_room: {
        name: '机舱',
        value: null,
      },

      other: {
        name: '轮上及其他',
        value: null,
      },
    }

    _.keys(car.images).forEach(rawkey => {
      _.keys(desired).forEach(desiredKey => {
        if (desiredKey === rawkey && car.images[rawkey]) {
          desired[desiredKey].value = car.images[rawkey]
        }
      })
    })

    return desired
  },

  // imagesGroupByCategoryFlattedbyCarId
  // “图片详情对应的图片分类”的 flat 版本
  imagesGroupByCategoryFlattedbyCarId: (store, getters) => id => {
    const {carByCarId, imagesGroupedByCategoryByCarId} = getters

    const car = carByCarId(id)
    const categories = imagesGroupedByCategoryByCarId(id)

    if (!car || !imagesGroupedByCategoryByCarId) {
      return null
    }

    return _.reduce(categories, (holder, category) => {
      const imgs = _.chain(category)
        .get('value')
        .map('img')
        .value()

      holder = [...holder, ...imgs]

      return holder
    }, [])
  },

  // recommendsByCarId 相关推荐
  recommendsByCarId: state => id => {
    return state.recommends[id]
      ? state.recommends[id]
      : null
  },

  // keyByCarId 钥匙编号
  keyByCarId:  (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.key_management && car.key_management.key_box_id
      ? car.key_management.key_box_id
      : null
  },

  // exteriorByCarId “外观”图
  // - images.facade
  exteriorByCarId: (store, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return _.chain(car.images)
      .get('facade')
      .map('img')
      .value()
  },

  // interiorsByCarId 内饰图片
  // images.interior_decoration
  interiorByCarId: (store, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return _.chain(car.images)
      .get('interior_decoration')
      .map('img')
      .value()
  },

  // attachmentListByCarId 附件清单
  attachmentListByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.attachment_list
  },

  hasAttachmentListByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.has_attachment_list
  },

  hasNewAttachMentListByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.has_new_attachment_list
  },

  // hasReportPreSalePreparation
  // - 2022.07.04
  // - 新版*整备报告*
  hasReportPreSalePreparation: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car)  {
      return null
    }

    return car.car.has_repair_list
  },

  // hasReportConsumable
  // - 2022.07.04
  // - 新版*耗材报告*
  hasReportConsumable: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.car.has_consumables_list
  },

  // reportEquipmentById
  // - 2022.08.02
  // - 自营-配置检查单
  reportEquipmentById: state => id => {
    const equipment = state
      && state.reportEquipment
      && state.reportEquipment[id]
      && state.reportEquipment[id]['report']

    if (equipment) {
      const processed = _
        .chain(equipment)
        .map((cate) => {
          const cloned = _.cloneDeep(cate)

          // cloned, cloned category in configuration
          // - if is_notes === true, skip
          // - else filter group.option, option should
          // at least has one which option.configuration = true
          cloned.group = cloned.is_notes
            ? cloned.group
            : _
              .filter(cate.group, (group) => {
                return _
                  .chain(group.options)
                  .filter((option) => {
                    return option.configuration
                  })
                  .size()
                  .value()
              })

          return cloned
        })
        .filter((cate) => {
          return cate.group.length
          || cate.is_notes
        })
        .value()

      return processed
    }
    else {
      return null
    }
  },

  // isMotocycle
  // - 2023.06.02
  isMotorcycleById: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.car.is_motorcycle
  },

  // exteriorVideoById
  // - 2023.06.12
  // - 绕车视频
  exteriorVideoById: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.car.vehicle_display_video
      && car.car.vehicle_display_video.internal_external
  },

  // newEnergyByCarId
  // - Date: 2023.09.13
  // - `new_energy` by car id
  newEnergyByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.car.new_energy
  },

  // financialAccount
  // - Date: 2023.09.13
  // - `company_info.bank_account`
  financialAccountByCarId: (_, {carByCarId}) => id => {
    const car = carByCarId(id)

    if (!car) {
      return null
    }

    return car.company_info
      && car.company_info.account_name
      || null
  },
}

// actions
const actions = {
  // fetchCar
  fetchCar: async (context, {params}) => {
    try {
      if (context.getters['carByCarId'](params.id)) {
        return
      }

      const rb = await getStandard({
        params,
      })

      if (rb) {
        if (rb.status === 'success'){
          context.commit('set_standard', {
            id: params.id,
            raw: rb.data,
          })
        }
      }
    }
    catch (err) {
      alert(err.message || err || JSON.stringify(err))
    }
  },

  // fetchRecommends
  fetchRecommends: async (context, {params}) => {
    try {
      if (context.getters['recommendsByCarId'](params.id)) {
        return
      }

      const rb = await getStandardRecommends({
        params,
      })

      if (rb) {
        if (rb.status === 'success'){
          context.commit('set_standard_recommends', {
            id: params.id,
            recommends: rb.data.cars,
          })
        }
      }
    }
    catch (err) {
      alert(err.message || err || JSON.stringify(err))
    }
  },

  // fetchEquipment
  async fetchEquipment (context, {params}) {
    try {
      // check if report equipment is already exist
      const id = params.module_id
      const equipment = context.getters['reportEquipmentById'](id)

      if (equipment) {
        return
      }

      const rb = await getInspectionReport({
        params,
      })

      if (rb) {
        if (rb.code === 2000000){
          context.commit('set_standard_report_equipment', {
            id,
            equipment: rb.data,
          })
        }
        else {
          throw new Error(rb.message)
        }
      }
    }
    catch (err) {
      // 2023.08.16
      // - Report equipment does not need error alert
      //   when it's null
      // alert(err.message || err || JSON.stringify(err))
    }
  },
}

// mutations
const mutations = {
  // set_standard
  set_standard: (state, {id, raw}) => {
    state.cars[`raw-${id}`] = raw
  },

  set_standard_recommends: (state, {id, recommends}) => {
    state.recommends[id] = recommends
  },

  // set_standard_report_equipment
  set_standard_report_equipment: (state, {id, equipment}) => {
    state.reportEquipment[id] = equipment
  },
}

const modules = {
  // Wholesale: WholesaleStore,
  Wholesale2: Wholesale2Store,
}

const CarStore = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
  modules,
}

export default CarStore
